var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard workout-list"},[_c('pageBanner'),_c('workoutsSlider'),_c('workoutCategories'),_c('workoutByAuthorSlider'),_c('workshopSlider')],1)}
var staticRenderFns = []

export { render, staticRenderFns }